import React from "react";
import styles from "./WhyPartner.module.css";
import {
  FaPrint,
  FaCog,
  FaTint,
  FaShieldAlt,
  FaThermometerHalf,
  FaMedal,
  FaBusinessTime,
  FaToolbox,
  FaHandshake,
  FaBriefcase,
} from "react-icons/fa";
import { FaHandshakeSimple } from "react-icons/fa6";

const WhyPartner = () => {
  const features = [
    {
      title: "Proven Business Model",
      description:
        "STEMx Studio offers channel partners an internationally accepted, recession-proof business model with low investment and high returns.",
      icon: <FaBriefcase />,
    },
    {
      title: "Simple & Effective Framework",
      description:
        "Our business model includes easy-to-follow training modules and market activation tools designed for quick implementation.",
      icon: <FaCog />,
    },
    {
      title: "Mutual Success",
      description:
        "A partnership built on hard work, sincerity, and our expertise ensures long-term profitability for both parties.",
      icon: <FaHandshakeSimple />,
    },
  ];

  return (
    <section className={styles.whyPartner}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">FEATURES & BENEFITS</h2>
        <p className={styles.subtitle}></p>
        <div className={styles.features}>
          {features.map((feature, index) => (
            <div
              key={index}
              className={styles.feature}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.iconWrapper}>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPartner;
